import * as React from "react";
import {
  Button,
  DialogActions,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
} from "@mui/material";
import { addDays, addMonths } from "date-fns";
import { MobileDateTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import esLocale from "date-fns/locale/es";

import PropTypes from "prop-types";

const SolicitarDias = (props) => {
  const { cantidad, open, onClose, onSave } = props;

  const [desde, setDesde] = React.useState(new Date());
  const [motivo, setMotivo] = React.useState("");
  const [minD, setMinD] = React.useState(new Date());
  const [maxD, setMaxD] = React.useState(new Date());
  React.useEffect(() => {
    const f = new Date();
    const min = addDays(f.setHours(f.getHours(), 0, 0), 2);
    const max = addMonths(min, 1);

    setMinD(min);
    setMaxD(max);
    setDesde(min);
  }, []);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Nueva solicitud de días</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ pt: 1 }}>
            <MobileDateTimePicker
              label="Desde"
              slotProps={{
                actionBar: {
                  actions: [],
                },
                toolbar: { hidden: true },
                textField: { size: "small", fullWidth: true },
              }}
              ampm={false}
              format="dd/MM/yyyy HH:00"
              minDateTime={minD}
              maxDateTime={maxD}
              timeSteps={{ hours: 1, minutes: 60 }}
              value={desde}
              autoFocus
              onChange={(v) => setDesde(v)}
              components={{ ActionBar: {} }}
              localeText={{
                okButtonLabel: "OK",
                cancelButtonLabel: "Cancelar",
              }}
              views={["month", "year", "day", "hours"]}
            />
            <TextField
              disabled
              label="Candidad de días"
              size="small"
              value={cantidad || "0"}
            />
            <TextField
              label="Motivo"
              size="small"
              multiline
              rows={2}
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={!(desde instanceof Date) || !motivo}
            onClick={() => onSave({ fecha: desde, motivo: motivo })}
          >
            Solicitar
          </Button>
          <Button onClick={onClose}>Cancelar</Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};
SolicitarDias.propTypes = {
  cantidad: PropTypes.number,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};
export default SolicitarDias;
